import { Link } from 'react-router-dom';
import { MusicNote, Heart, HeartBreak } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

export const MusicianCard = ({ musician, index = 0, isFavorite = false, onToggleFavorite }) => {
  const API = process.env.REACT_APP_BACKEND_URL;

  const getImageUrl = () => {
    if (musician.profile_image) {
      return `${API}/api/files/${musician.profile_image}`;
    }
    return null;
  };

  const handleFavoriteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onToggleFavorite) {
      onToggleFavorite(musician);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
    >
      <Link
        to={`/musician/${musician.id}`}
        className="musician-card block group"
        data-testid={`musician-card-${musician.id}`}
      >
        {/* Image */}
        <div className="aspect-square relative overflow-hidden">
          {getImageUrl() ? (
            <img
              src={getImageUrl()}
              alt={musician.name}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-[#1A1A1A] to-[#111] flex items-center justify-center">
              <MusicNote size={48} weight="fill" className="text-[#333]" />
            </div>
          )}
          
          {/* Favorite Button */}
          {onToggleFavorite && (
            <button
              onClick={handleFavoriteClick}
              className="absolute top-3 right-3 w-10 h-10 rounded-full bg-black/60 backdrop-blur flex items-center justify-center text-white hover:text-[#FF0055] transition-colors"
              data-testid={`favorite-btn-${musician.id}`}
            >
              {isFavorite ? (
                <Heart size={20} weight="fill" className="text-[#FF0055]" />
              ) : (
                <Heart size={20} />
              )}
            </button>
          )}

          {/* Overlay on hover */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>

        {/* Info */}
        <div className="p-4">
          <h3 className="font-semibold text-white truncate group-hover:text-[#CCFF00] transition-colors">
            {musician.name}
          </h3>
          <div className="flex flex-wrap items-center gap-1 mt-2">
            {musician.genres && musician.genres.length > 0 ? (
              musician.genres.slice(0, 2).map(genre => (
                <span key={genre} className="text-xs text-[#A1A1AA] bg-white/5 px-2 py-0.5 rounded-full">
                  {genre}
                </span>
              ))
            ) : musician.genre && (
              <span className="text-xs text-[#A1A1AA] bg-white/5 px-2 py-0.5 rounded-full">
                {musician.genre}
              </span>
            )}
            {musician.genres && musician.genres.length > 2 && (
              <span className="text-xs text-[#666]">+{musician.genres.length - 2}</span>
            )}
          </div>
          {musician.location && (
            <p className="text-xs text-[#666] mt-1 truncate">{musician.location}</p>
          )}
          {musician.track_count !== undefined && (
            <p className="text-sm text-[#A1A1AA] mt-2">
              {musician.track_count} {musician.track_count === 1 ? 'brano' : 'brani'}
            </p>
          )}
        </div>
      </Link>
    </motion.div>
  );
};
